import axios from "axios";

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_URL, withCredentials: true });

api.interceptors.request.use((config) => {
  const imp = localStorage.getItem("impersonate_token");
  if (imp) config.headers.Authorization = `Bearer ${imp}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { config, response } = error;
    if (response?.status === 401 && localStorage.getItem("impersonate_token") && !config._impersonateRetried) {
      localStorage.removeItem("impersonate_token");
      config._impersonateRetried = true;
      delete config.headers.Authorization;
      return api(config);
    }
    return Promise.reject(error);
  }
);

export function customerClient() {
  const t = localStorage.getItem("customer_token");
  return axios.create({
    baseURL: API_URL,
    headers: t ? { Authorization: `Bearer ${t}` } : {},
  });
}

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  return String(d.msg || d);
}

export default api;
